import React from 'react';
// import pages
import Home from '../pages/Home';
import About from '../pages/About';
import Portfolio from '../pages/Portfolio';
import Contact from '../pages/Contact';
import Works from '../pages/Works';
import Hero from '../pages/Hero';
import OpenCalls from '../pages/OpenCalls';
import Gallery from '../pages/Gallery';
import We from '../pages/We';
import MGOP from './MGOP';
import WowAlbum from '../pages/WowAlbum'
import MgopAlbum from '../pages/MgopAlbum'
// import routes route & useLocation hook
import { Routes, Route, useLocation, Router } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Edition1 from '../pages/Edition1';
import Edition2 from '../pages/Edition2';
import Editions from '../pages/Editions';
import WeightOfWaters from './WeightofWaters';

const AnimRoutes = () => {
  const location = useLocation();
  return (
    <AnimatePresence initial={true} mode='wait'>
      <Routes key={location.pathname} location={location}>
        <Route path='/' element={<Portfolio />} />
        <Route path='/about' element={<About />} />
        <Route path='/portfolio' element={<Portfolio />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/works' element={<Works />} />
        <Route path='/hero' element={<Hero />} />
        <Route path='/open-calls' element={<OpenCalls/>} />
        <Route path='/edition1' element={<Edition1/>}/>
        <Route path='/edition2' element={<Edition2/>}/>
        <Route path='/projects' element={<Editions/>}/>
        <Route path='/gallery' element={<Gallery/>}/>
        <Route path='/we-collective' element={<We/>}/>
        <Route path='/WeightofWaters' element={<WeightOfWaters/>}/>
        <Route path='/MGOP' element={<MGOP/>}/>
        <Route path='/We' element={<We/>}/>
        <Route path='/Album' element={<Gallery/>}/>
        <Route path='/WeCollective-album' element={<Works/>}/>
        <Route path='/WeightofWaters-album' element={<WowAlbum/>}/>
        <Route path='/MappingGeographiesofPower-album' element={<MgopAlbum/>}/>
      </Routes>
    </AnimatePresence>
  );
};

export default AnimRoutes;
